import { render, staticRenderFns } from "./CollapsedMenu.vue?vue&type=template&id=73f6db3e&"
import script from "./CollapsedMenu.vue?vue&type=script&lang=js&"
export * from "./CollapsedMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports